import { INTERNAL_DATA_LAKE_ID } from "data-lake/preview/storage-types/internal/Constants";
const findDataLakeIdInSearchType = (activeSearch) => {
  var _a;
  const searchTypes = (_a = activeSearch.queries.first().searchTypes) == null ? void 0 : _a[0];
  return "data_lake_id" in searchTypes && searchTypes.data_lake_id ? searchTypes.data_lake_id : INTERNAL_DATA_LAKE_ID;
};
export default findDataLakeIdInSearchType;
